export default {
  top: 'top',
  bottom: 'bottom',
  position: 'position',
};
